import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Box = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
    padding: 20px;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const Text = styled.p`
    margin: 0;
    font-size: 0.875rem;
    color: ${colors.textSecondary};
    max-width: 460px;
`;
